<template>
  <div class="about-mobile">
    <div class="box" id="Overview">
      <div>
        <p class="size16 family2">{{$t('AboutUs.title')}}</p>
        <div style="margin:0.2rem 0 0.4rem 0;">
          <img src="../assets/about-mobile/173333414 .png" style="width:3.35rem;" />
        </div>
        <p class="size12 family4">
          {{$t('AboutUs.des1')}}{{$t('AboutUs.des11')}}
          <span class="family2">{{$t('AboutUs.des12')}}</span>
          {{$t('AboutUs.des13')}}
        </p>
        <p class="size12 family4" style="margin:0.15rem 0;">{{$t('AboutUs.des2')}}</p>

        <a
          href="https://www.redteamobile.com/红茶移动企业简介-中文_20200827.pdf"
          target="blank"
          style="color:rgba(211, 36, 23, 1);"
          v-show="!langShow"
        >
          <div style="display:flex;align-items:center;justify-content:center;margin-bottom:0.4rem;">
            <img src="../assets/about-mobile/下载.svg" style="width:0.15rem;margin-right:0.1rem;" />
            <span class="size14 family1" style="cursor:pointer;">{{$t('AboutUs.download')}}</span>
          </div>
        </a>
        <a
          href="https://www.redteamobile.com/Redtea Mobile Company Profile_20200827.pdf"
          target="blank"
          style="color:rgba(211, 36, 23, 1);"
          v-show="langShow"
        >
          <div style="display:flex;align-items:center;justify-content:center;margin-bottom:0.4rem;">
            <img src="../assets/about-mobile/下载.svg" style="width:0.15rem;margin-right:0.1rem;" />
            <span class="size14 family1" style="cursor:pointer;">{{$t('AboutUs.download')}}</span>
          </div>
        </a>
      </div>
    </div>

    <div style="background:rgba(117, 130, 154, 1);color:rgba(255, 255, 255, 0.8);padding:0.3rem 0;">
      <div class="box our" style="text-align:left;">
        <p
          class="size12 family2 before-img1"
          style="margin-bottom:0.1rem;position:relative;margin-left:25px"
          id="Mission"
        >{{$t('AboutUs.mission.title')}}</p>
        <p class="size12 family4">{{$t('AboutUs.mission.des1')}}</p>
        <p class="size12 family4" style="margin-bottom:0.2rem;">- {{$t('AboutUs.mission.des2')}}</p>
        <p
          class="size12 family2 before-img2"
          style="margin-bottom:0.1rem;position:relative;margin-left:25px"
          id="Vision"
        >{{$t('AboutUs.vision.title')}}</p>
        <p class="size12 family4">{{$t('AboutUs.vision.des1')}}</p>
        <p class="size12 family4" style="margin-bottom:0.2rem;">- {{$t('AboutUs.vision.des2')}}</p>
        <p
          class="size12 family2 before-img3"
          style="margin-bottom:0.1rem;position:relative;margin-left:25px"
          id="Values"
        >{{$t('AboutUs.values.title')}}</p>
        <p class="size12 family4">{{$t('AboutUs.values.des')}}</p>
        <p class="size12 family4">-{{$t('AboutUs.values.title1')}}</p>
        <ul style="margin-left:20px">
          <li class="size12 family4">{{$t('AboutUs.values.text1')}}</li>
          <li class="size12 family4">{{$t('AboutUs.values.text2')}}</li>
          <li class="size12 family4">{{$t('AboutUs.values.text3')}}</li>
          <li class="size12 family4">{{$t('AboutUs.values.text4')}}</li>
        </ul>
        <p class="size12 family4">-{{$t('AboutUs.values.title2')}}</p>
        <ul style="margin-left:20px">
          <li class="size12 family4">{{$t('AboutUs.values.text5')}}</li>
          <li class="size12 family4">{{$t('AboutUs.values.text6')}}</li>
          <li class="size12 family4">{{$t('AboutUs.values.text7')}}</li>
          <li class="size12 family4">{{$t('AboutUs.values.text8')}}</li>
        </ul>
      </div>
    </div>

    <div class="box recognition" id="Recognition">
      <p
        class="size16 family2"
        style="margin-bottom:0.2rem;text-align:center;margin-top:0.4rem;"
      >{{$t('AboutUs.recog.title')}}</p>
      <p
        class="size12 family4"
        style="text-align:left;margin-bottom:0.1rem;"
      >{{$t('AboutUs.recog.des')}}</p>
      <div style="margin-bottom:0.4rem;">
        <div class="radius-box size7 family1">{{$t('AboutUs.recog.content1')}}</div>
        <div class="radius-box size7 family1">{{$t('AboutUs.recog.content2')}}</div>
        <div class="radius-box size7 family1">{{$t('AboutUs.recog.content3')}}</div>
        <div class="radius-box size7 family1">{{$t('AboutUs.recog.content4')}}</div>
        <div class="radius-box size7 family1">{{$t('AboutUs.recog.content5')}}</div>
        <div class="radius-box size7 family1">{{$t('AboutUs.recog.content6')}}</div>
        <div class="radius-box size7 family1">{{$t('AboutUs.recog.content7')}}</div>
        <div class="radius-box size7 family1">{{$t('AboutUs.recog.content8')}}</div>
        <div class="radius-box size7 family1">{{$t('AboutUs.recog.content9')}}</div>
        <div class="radius-box size7 family1">{{$t('AboutUs.recog.content10')}}</div>
        <div class="radius-box size7 family1">{{$t('AboutUs.recog.content11')}}</div>
        <div class="radius-box size7 family1">{{$t('AboutUs.recog.content12')}}</div>
      </div>
    </div>

    <div class="box partner" style="padding-top:1.2rem" id="Careers">
      <p
        class="size16 family2"
        style="text-align:center;margin-bottom:0.2rem;"
      >{{$t('AboutUs.partner.title')}}</p>
      <p class="size12 family4">
        {{$t('AboutUs.partner.des')}}
        <span
          style="color:rgb(211, 36, 23);"
        >{{$t('AboutUs.partner.des1')}}</span>
      </p>
      <p class="size12 family2"></p>
    </div>

    <div class="box diff" style="padding-top:0.4rem" id="Team">
      <div>
        <p
          class="size16 family2"
          style="text-align:center;margin-bottom:0.2rem;"
        >{{$t('AboutUs.diff.title')}}</p>
        <p class="size12 family4">{{$t('AboutUs.diff.des1')}}</p>
        <p class="size12 family4">{{$t('AboutUs.diff.des2')}}</p>
        <p class="size12 family4" style="text-align:left;">- {{$t('AboutUs.diff.text1')}}</p>
        <p class="size12 family4" style="text-align:left;">- {{$t('AboutUs.diff.text2')}}</p>
        <p class="size12 family4" style="text-align:left;">- {{$t('AboutUs.diff.text3')}}</p>
        <p class="size12 family4" style="text-align:left;">- {{$t('AboutUs.diff.text4')}}t</p>
        <p
          class="size12 family2"
          style="text-align:left;margin-top:0.1rem;"
        >{{$t('AboutUs.diff.text5')}}</p>
        <p class="size12 family2" style="text-align:left;">
          {{$t('AboutUs.diff.text6')}}
          <span
            style="color:rgb(211, 36, 23);"
          >{{$t('AboutUs.diff.text7')}}</span>
        </p>
      </div>
      <div style="margin-top:0.2rem;font-family:'Poppins-ExtraLight';font-size:0.12rem;">
        <p class="job-title">{{$t('AboutUs.diff.job1')}}</p>
        <ul style="margin-left:0.2rem;">
          <li>{{$t('AboutUs.diff.jobDes1')}}</li>
          <li>{{$t('AboutUs.diff.jobDes2')}}</li>
        </ul>
        <p class="job-title">{{$t('AboutUs.diff.job2')}}</p>
        <ul style="margin-left:0.2rem;">
          <li>{{$t('AboutUs.diff.jobDes3')}}</li>
          <li>{{$t('AboutUs.diff.jobDes4')}}</li>
          <li>{{$t('AboutUs.diff.jobDes5')}}</li>
        </ul>
        <p class="job-title">{{$t('AboutUs.diff.job3')}}</p>
        <ul style="margin-left:0.2rem;">
          <li>{{$t('AboutUs.diff.jobDes6')}}</li>
          <li>{{$t('AboutUs.diff.jobDes7')}}</li>
          <li>{{$t('AboutUs.diff.jobDes8')}}</li>
        </ul>
        <p class="job-title">{{$t('AboutUs.diff.job4')}}</p>
        <ul style="margin-left:0.2rem;">
          <li>{{$t('AboutUs.diff.jobDes9')}}</li>
          <li>{{$t('AboutUs.diff.jobDes10')}}</li>
          <li>{{$t('AboutUs.diff.jobDes11')}}</li>
        </ul>
      </div>
    </div>

    <div class="box gallery">
      <p
        class="size16 family2"
        style="text-align:center;margin:0.4rem 0 0.2rem 0;"
      >{{$t('AboutUs.gallery')}}</p>
      <Carousel
        v-model="value3"
        :autoplay="true"
        :radius-dot="true"
        trigger="hover"
        arrow="always"
        :autoplay-speed="4000"
        loop
      >
        <CarouselItem>
          <div class="demo-carousel">
            <img src="../assets/about-mobile/_DSC1076 2.png" />
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <img src="../assets/about-web/1.png" />
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <img src="../assets/about-web/2.png" />
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <img src="../assets/about-web/3.png" />
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <img src="../assets/about-web/4.png" />
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel">
            <img src="../assets/about-web/5.png" />
          </div>
        </CarouselItem>
      </Carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about-mobile',
  components: {},
  data() {
    return {
      value3: 0
    }
  },
  computed: {
    langShow: function() {
      return this.$store.state.localLang === 'en' ? true : false
    }
  }
}
</script>
<style lang="less" scoped>
.about-mobile {
  padding-top: 1rem;
  color: rgba(32, 49, 82, 1);
  .box {
    text-align: left;
    padding: 0 0.2rem;
  }
  .family1 {
    font-family: 'Poppins-Light';
  }
  .family2 {
    font-family: 'Poppins-Regular';
  }
  .family3 {
    font-family: 'Poppins-Bold';
  }
  .family4 {
    font-family: 'Poppins-ExtraLight';
  }
  .size16 {
    font-size: 0.16rem;
  }
  .size14 {
    font-size: 0.14rem;
  }
  .size12 {
    font-size: 0.12rem;
  }
  .size7 {
    font-size: 0.07rem;
  }
  .radius-box {
    width: 1.06rem;
    height: 0.3rem;
    border-radius: 0.06rem;
    border: 1px solid rgba(32, 49, 82, 0.4);
    float: left;
    margin: 0.05rem 0.05rem 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .ra-box {
    width: 1.62rem;
    height: 0.8rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 40px 0px rgba(0, 0, 0, 0.05);
    padding-top: 0.1rem;
    text-align: center;
  }
  .gallery {
    padding-bottom: 0.4rem;
  }
  .job-title {
    font-family: 'Poppins-Light';
    font-weight: bold;
    margin: 0.2rem 0 0.1rem 0;
  }
  .before-img1:before {
    background-image: url('../assets/about-web/1@2x.svg');
    content: '';
    background-size: 20px 20px;
    position: absolute;
    width: 20px;
    height: 20px;
    left: -30px;
    top: -2px;
  }
  .before-img2:before {
    background-image: url('../assets/about-web/2@2x.svg');
    content: '';
    background-size: 20px 20px;
    position: absolute;
    width: 20px;
    height: 20px;
    left: -30px;
    top: -2px;
  }
  .before-img3:before {
    background-image: url('../assets/about-web/3@2x.svg');
    content: '';
    background-size: 20px 20px;
    position: absolute;
    width: 20px;
    height: 20px;
    left: -30px;
    top: -2px;
  }
}
</style>
